export const getDataSDKFromVnpay = async () => {
  return {
    data: {},
    error: null
  }
}
